import classNames from "classnames";
import { SearchButton } from "../../../Components/Buttons/SearchButton";
import { TEntityInfo } from "../../../types/utility";
import { MenuItem, MenuItems, TSidebarActions } from "../../types";
import { AppLoading } from "../../../../shared/components/AppLoading";
import { SidebarLayoutButton } from "../SidebarButtons/SidebarLayoutButton";
import { SidebarSearchPanel } from "../SidebarSearchPanel";
import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import { SidebarSearchPopover } from "../SidebarSearchPopover";
import { useAppPopovers } from "../../../../app/state/popoverSlice/hook/use-app-popovers";
import { SidebarItemsAutocomplete } from "../SidebarItemsAutocomplete";
import { RefreshSidebarDataButton } from "../RefreshSidebarDataButton";
import styles from "./styles.module.css";

interface Props {
  service: StorageScope;
  searchQuery: string;
  isSearchPanelOpen: boolean;
  isSidebarOpen: boolean;
  menuItems: MenuItems;
  menuItem: MenuItem | null;
  addButton: React.ReactNode;
  onSelectItem: (item: MenuItem | null) => void;
  handleActions: (
    type: TSidebarActions,
    info: TEntityInfo | null,
    e?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  extraAction?: React.ReactElement;
  isLoading?: boolean;
  className?: string;
}

export const SidebarHeader = ({
  service,
  addButton,
  searchQuery,
  isSearchPanelOpen,
  isSidebarOpen,
  menuItems,
  menuItem,
  onSelectItem,
  handleActions,
  extraAction,
  isLoading,
  className,
}: Props) => {
  const { handleClosePopover, handleOpenPopover } = useAppPopovers();

  const actionCls = classNames(
    styles["header-right-block"],
    !isSidebarOpen && styles["actions-column"],
  );

  const actionCommonCls = classNames(
    styles["action-wrapper"],
    !isSidebarOpen && styles["actions-common-column"],
  );

  return (
    <div
      className={classNames(
        styles["sidebar-header"],
        !isSidebarOpen && styles["sidebar-header-close"],
      )}
    >
      <div className={actionCommonCls}>
        {!isSidebarOpen && (
          <SidebarLayoutButton
            isSidebarOpen={isSidebarOpen}
            handleSidebarLayoutControl={() =>
              handleActions("sidebar_layout_control", null)
            }
          />
        )}
        {addButton}
        {service !== "practicum" && (
          <div className={actionCls}>
            {extraAction && extraAction}
            <RefreshSidebarDataButton
              service={service}
              isLoading={isLoading ?? false}
            />
            {service !== "knowledge_base" && (
              <SearchButton
                onClick={(e) => {
                  isSidebarOpen
                    ? handleActions("search", null)
                    : handleOpenPopover(e, "sidebar_search_popover", null);
                }}
              />
            )}

            {isSidebarOpen && (
              <SidebarLayoutButton
                isSidebarOpen={isSidebarOpen}
                handleSidebarLayoutControl={() =>
                  handleActions("sidebar_layout_control", null)
                }
              />
            )}
          </div>
        )}
      </div>
      {isSidebarOpen ? (
        <SidebarSearchPanel
          searchQuery={searchQuery}
          handleSearchActions={handleActions}
          isSearchPanelOpen={isSearchPanelOpen}
          isSidebarOpen={isSidebarOpen}
        />
      ) : (
        <SidebarSearchPopover
          closePopover={handleClosePopover}
          children={
            <SidebarItemsAutocomplete
              menuItems={menuItems}
              menuItem={menuItem}
              onSelectItem={onSelectItem}
            />
          }
        />
      )}
    </div>
  );
};
